import { render, staticRenderFns } from "./AnalyticsScreenResolutionsReport.vue?vue&type=template&id=71687037&scoped=true&"
import script from "./AnalyticsScreenResolutionsReport.vue?vue&type=script&lang=js&"
export * from "./AnalyticsScreenResolutionsReport.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsScreenResolutionsReport.vue?vue&type=style&index=0&id=71687037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71687037",
  null
  
)

export default component.exports